<template>
    <div>
        <template v-if="title">
            <a v-if="checkLinkValue" :href="row[linkIndex]" target="_blank" rel="noreferrer" v-popover:tooltip="t(title)">{{ row[column.data] }}</a>
            <span v-else v-popover:tooltip="t(title)">{{ row[column.data] }}</span>
        </template>
        <template v-else>
            <a v-if="checkLinkValue" :href="row[linkIndex]" target="_blank" rel="noreferrer">{{ row[column.data] }}</a>
            <span v-else>{{ row[column.data] }}</span>
        </template>
    </div>
</template>

<script>

import ValueChecker from "../../services/ValueChecker";

export default
{
    components: {},
    props: {
        column: {
            type: Object,
        },
        config: {
            type: Object,
            default: function() {
                return {
                    linkIndex: undefined
                }
            }
        },
        row: {
            type: Object,
        },
        title: {
            type: String
        },
    },
    data() {
        return {

        };
    },
    computed: {
        linkIndex() {
            if (!ValueChecker.isUndefinedOrNull(this.config.linkIndex)) {
                return this.config.linkIndex;
            }

            return 'offer_link';
        },
        checkLinkValue() {
            return !ValueChecker.isUndefinedOrNull(this.row[this.linkIndex]);
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>



// WEBPACK FOOTER //
// ProductLinkComponent.vue?fc5bedba